module.exports = __webpack_public_path__ + "img/expand-right.a13559d4.png";